import { Controller } from "@hotwired/stimulus"

// Controls the targeting section of the survey form:
//   - Region must be picked first — hides target-type + car pickers until set.
//   - Target type public → hide car cascade; car → show category → car cascade.
//   - The car <select> is rebuilt from the full car list filtered by the chosen
//     REGION and CATEGORY. Rebuilding (not just hiding <option>s) keeps it
//     correct under the searchable-select combobox, which renders its own list
//     and re-syncs on option changes.
export default class extends Controller {
  static targets = [
    "regionSelect", "regionHint", "targetSection",
    "radio", "carSelect", "categorySelect", "carDropdown"
  ]

  static values = { cars: Array }

  connect() {
    this.syncRegionVisibility()
    this.filterCars()
  }

  regionChanged() {
    this.syncRegionVisibility()
    this.filterCars()
  }

  syncRegionVisibility() {
    if (!this.hasRegionSelectTarget) return
    const hasRegion = !!this.regionSelectTarget.value
    if (this.hasTargetSectionTarget) this.targetSectionTarget.classList.toggle("hidden", !hasRegion)
    if (this.hasRegionHintTarget) this.regionHintTarget.classList.toggle("hidden", hasRegion)
  }

  toggle() {
    const selected = this.radioTargets.find(r => r.checked)?.value
    if (this.hasCarSelectTarget) this.carSelectTarget.classList.toggle("hidden", selected !== "car")
  }

  // Rebuild the car dropdown for the selected region + category, preserving the
  // current selection when it still qualifies.
  filterCars() {
    if (!this.hasCarDropdownTarget) return

    const regionId = this.hasRegionSelectTarget ? this.regionSelectTarget.value : ""
    const categoryId = this.hasCategorySelectTarget ? this.categorySelectTarget.value : ""
    const dropdown = this.carDropdownTarget
    const selected = dropdown.value
    const blank = dropdown.querySelector('option[value=""]')

    const matches = (this.carsValue || []).filter(car =>
      (!regionId || (car.regionIds || []).includes(regionId)) &&
      (!categoryId || String(car.categoryId) === String(categoryId))
    )

    const options = []
    if (blank) options.push(blank.cloneNode(true))
    matches.forEach(car => {
      const opt = document.createElement("option")
      opt.value = car.id
      opt.textContent = car.name
      opt.dataset.categoryId = car.categoryId || ""
      if (car.id === selected) opt.selected = true
      options.push(opt)
    })

    // Replacing the options fires the searchable-select observer, which
    // re-renders its combobox list from the new set.
    dropdown.replaceChildren(...options)
  }
}
